// ============================================
// CLIENT-SIDE APPKIT STUB
// ============================================
// MUST be the very first import to run BEFORE any AppKit-using components.
// This synchronously sets up a stub that satisfies hooks during hydration.
import '../appkit-client-stub';

import { createRootRoute, redirect } from '@tanstack/react-router'
import App from '../App'
import ErrorComponent from './-errorComponent'
import NotFound from './-not-found'
import { ErrorBoundary } from '../components/ErrorBoundary'
import { detectClientLocale, locales } from '../i18n/translator'

const SUPPORTED = new Set(Object.keys(locales))

const RootWithBoundary = () => (
  <App />
)

export const Route = createRootRoute({
  component: RootWithBoundary,
  errorComponent: ErrorComponent,
  notFoundComponent: NotFound,
  beforeLoad: ({ location }) => {
    // Gate: any URL whose first segment is NOT a supported locale gets
    // redirected to the locale-prefixed version, keeping the current
    // browser language. The $locale route then handles real locale URLs.
    const first = location.pathname.split('/').filter(Boolean)[0]
    if (!first || !SUPPORTED.has(first)) {
      const detected = detectClientLocale()
      const rest = location.pathname === '/' ? '/' : location.pathname
      const target = `/${detected}${rest === '/' ? '/' : rest}`
      throw redirect({ href: target, statusCode: 302 })
    }
  },
})
